// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1JK2Q","upload":"Small_upload__J3JsI","imageWrap":"Small_imageWrap__1FCFI","removeBtn":"Small_removeBtn__1jA4r"};